import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "./Components/Header";
import NavBar from "./Components/NavBar";
import useAuth from "./useAuth";
import Footer from "./Components/global/Footer";

export default function AppAuth() {
  const { user } = useAuth();
  const location = useLocation();
  const pathname = location.pathname?.split("/")?.[2];

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="min-h-screen flex bg-slate-50">
      {/* Sidebar Desktop */}
      <aside className="w-64 fixed top-0 left-0 bottom-0 z-30 hidden lg:block shadow-xl">
        <NavBar />
      </aside>

      {/* Main Content Area */}
      <div className="flex-1 lg:ml-64 flex flex-col min-h-screen bg-slate-50">
        <Header />
        
        <main className="flex-1 p-6 z-10 bg-slate-50 text-slate-800">
          <Outlet />
        </main>

        {!["whatsAppChat", "sendTemplate"]?.includes(pathname) && <Footer />}
      </div>
    </div>
  );
}
